import { useSignalR } from './use-signalr.hook';
import { IChannelApi, IChatApiMessage, IChatMessage } from '@vivli/features/chat/infrastructure/interface';
import { useAppConfigContext, useAuthServiceContext, useChatApiContext } from '@vivli/core/infrastructure/context';

interface UseChannelHookProps {
    channelId: string;
    onStart?: (channel: IChannelApi) => void;
    onStop?: () => void;
    onMessage?: ((message: IChatApiMessage) => void) | ((message: IChatMessage) => void);
    onError?: (err) => void;
}

export const useChannel = ({ channelId, onStart, onStop, onMessage, onError }: UseChannelHookProps): void => {
    const { getAccount, getTokenSilent } = useAuthServiceContext();
    const config = useAppConfigContext();
    const chatService = useChatApiContext();

    const send = (message: IChatMessage, sendToLocal?: boolean) => {
        if (sendToLocal) {
            // @ts-expect-error ignore, works as intended
            onMessage && onMessage(message);
        }

        return chatService.postChatMessage(channelId, message.text);
    };

    const apiToken = getAccount()?.idToken;
    const channelUri = channelId ? `${config.chatUri}chat?channelId=${encodeURI(channelId)}&jwt=${encodeURI(apiToken)}` : null;

    const handleMessageReceived = (message: IChatApiMessage) => {
        if (!message || message.channelId !== channelId) {
            return;
        }
        getTokenSilent().then(() => {
            // calling get token popup to refresh app token, aka keep the chat page alive if a message is received
        });
        onMessage && onMessage(message);
    };

    useSignalR<IChatApiMessage>({
        uri: channelUri,
        events: ['receiveChatMessage'],
        onStart: () => onStart && onStart({ send }),
        onStop: () => onStop && onStop(),
        onEvent: handleMessageReceived,
        onError
    });
};
